import React, {useState} from "react";
import NavbarHome from "./NavbarHome";

const Home = () => {

  const [state, setState] = useState('world')
  return (
    <>
    
    </>
  );
};

export default Home;
